module.exports = __webpack_public_path__ + "static/media/logo.7dd80909.svg";